import Card from '../payment/card';
export default class PayerIdentification {
  public type = 'CPF';
  public number?: string;

  constructor(card: Card) {
    this.type = card.identificationType;
    this.number = card?.document?.replace(/\D/g, '') || '';
  }
}
